import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js";

/**
 * Drop zone for unplacing tables from the floor plan
 * Accepts table drops and clears their grid position
 * Optimistic updates - hides element immediately, reloads on error
 */
export default class extends Controller {
  connect() {
    this.element.addEventListener("dragover", this.handleDragOver.bind(this));
    this.element.addEventListener("dragleave", this.handleDragLeave.bind(this));
    this.element.addEventListener("drop", this.handleDrop.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("dragover", this.handleDragOver);
    this.element.removeEventListener("dragleave", this.handleDragLeave);
    this.element.removeEventListener("drop", this.handleDrop);
  }

  handleDragOver(event) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    this.element.classList.add("ring-2", "ring-warning");
  }

  handleDragLeave(event) {
    this.element.classList.remove("ring-2", "ring-warning");
  }

  handleDrop(event) {
    event.preventDefault();
    this.element.classList.remove("ring-2", "ring-warning");

    const tableId = event.dataTransfer.getData("text/plain");
    if (!tableId) return;

    // Signal to floor-plan controller that drop succeeded
    const floorPlanController = document.querySelector("[data-controller*='floor-plan']");
    if (floorPlanController) {
      const controller = this.application.getControllerForElementAndIdentifier(
        floorPlanController,
        "floor-plan"
      );
      if (controller) controller.dropSucceeded = true;
    }

    // Hide table on floor plan immediately (optimistic UI)
    const tableOnFloor = document.querySelector(
      `[data-floor-plan-target='grid'] [data-table-id="${tableId}"]`
    );
    if (tableOnFloor) {
      tableOnFloor.style.display = "none";
    }

    this.unplaceTable(tableId);
  }

  async unplaceTable(tableId) {
    const venueId = this.getVenueIdFromUrl();
    const url = `/venues/${venueId}/tables/${tableId}/position`;

    try {
      const response = await patch(url, {
        body: {
          admin_venues_tables_positions_update_form: {
            grid_x: null,
            grid_y: null,
          },
        },
      });

      if (response.ok) {
        window.location.reload();
      } else {
        console.error("Failed to unplace table");
      }
    } catch (error) {
      console.error("Error unplacing table:", error);
    }
  }

  getVenueIdFromUrl() {
    const pathParts = window.location.pathname.split("/");
    const venueIndex = pathParts.indexOf("venues");
    return pathParts[venueIndex + 1];
  }
}
